const attendance = {
  // Page meta
  studentAttendance: 'الحضور اليومي للطلاب',
  studentAttendanceSubtitle: 'نظرة عامة على الحضور اليومي للطلاب عبر جميع الفصول',
  teacherAttendanceTitle: 'حضور الفصل',
  staffAttendance: 'حضور الموظفين',
  staffAttendanceSubtitle: 'تتبع الحضور اليومي لجميع طاقم التدريس والعلاج',
  // Date navigator
  todayAttendance: 'حضور اليوم',
  attendanceRecord: 'سجل الحضور',
  previousDay: 'اليوم السابق',
  nextDay: 'اليوم التالي',
  // Stats bar
  attendanceRate: 'نسبة الحضور',
  bestAttendance: 'أفضل حضور',
  needsAttention: 'بحاجة للمتابعة',
  totalStaff: 'إجمالي الموظفين',
  present: 'حاضر',
  absent: 'غائب',
  halfDay: 'نصف يوم',
  onLeave: 'في إجازة',
  // Table columns
  student: 'الطالب',
  class: 'الفصل',
  attendance: 'الحضور',
  remark: 'ملاحظة',
  call: 'اتصال',
  staff: 'الموظف',
  checkIn: 'تسجيل الدخول',
  checkOut: 'تسجيل الخروج',
  status: 'الحالة',
  // Toggle
  presentLabel: 'حاضر',
  absentLabel: 'غائب',
  presentClickToAbsent: 'حاضر — انقر لتغييره إلى غائب',
  absentClickToPresent: 'غائب — انقر لتغييره إلى حاضر',
  tapToToggle: '— انقر للتبديل',
  noRemark: 'لا توجد ملاحظة',
  addRemark: 'إضافة ملاحظة...',
  editRemark: 'تعديل الملاحظة',
  // Bulk actions
  markAllPresent: 'تعيين الكل كحاضر',
  markAllAbsent: 'تعيين الكل كغائب',
  markAllPresentTitle: 'تعيين الكل كحاضر؟',
  markAllAbsentTitle: 'تعيين الكل كغائب؟',
  markAllPresentMessage: 'سيتم تعيين جميع الطلاب ({{count}}) كحاضرين لليوم. هل أنت متأكد؟',
  markAllAbsentMessage: 'سيتم تعيين جميع الطلاب ({{count}}) كغائبين لليوم. هل أنت متأكد؟',
  markAllStaffPresentMessage: 'سيتم تعيين جميع الموظفين ({{count}}) كحاضرين لليوم. هل أنت متأكد؟',
  markAllStaffAbsentMessage: 'سيتم تعيين جميع الموظفين ({{count}}) كغائبين لليوم. هل أنت متأكد؟',
  // Notify parents
  notifyParents: 'إشعار {{count}} ولي أمر',
  notifyParentsPlural: 'إشعار {{count}} أولياء أمور',
  absentStudentsToday: '{{count}} طالب غائب اليوم',
  absentStudentsTodayPlural: '{{count}} طلاب غائبين اليوم',
  sendAbsenceAlerts: 'إرسال تنبيهات الغياب؟',
  notifyAbsenceMessage: 'سيتم إشعار أولياء أمور {{count}} طالب غائب ({{names}}). سيتلقى أولياء الأمور بريداً إلكترونياً بتفاصيل غياب اليوم.',
  notifyAbsenceMessagePlural: 'سيتم إشعار أولياء أمور {{count}} طلاب غائبين ({{names}}). سيتلقى أولياء الأمور بريداً إلكترونياً بتفاصيل غياب اليوم.',
  parentsNotified: 'تم إشعار أولياء الأمور',
  absenceAlertsSent: 'تم إرسال تنبيهات الغياب لـ <strong>{{count}} طالب</strong> — {{names}}{{suffix}}.',
  absenceAlertsSentPlural: 'تم إرسال تنبيهات الغياب لـ <strong>{{count}} طلاب</strong> — {{names}}{{suffix}}.',
  andMore: ' و {{count}} آخرين',
  // Footer
  studentsShown: '{{count}} طالب معروض',
  staffShown: '{{count}} موظف معروض',
  readOnlyHistorical: 'للقراءة فقط — سجل تاريخي',
  toggleToMark: 'انقر للتبديل لتسجيل الحضور',
  // Empty states
  noAttendanceRecords: 'لم يتم العثور على سجلات حضور',
  noStaffAttendanceRecords: 'لم يتم العثور على سجلات حضور للموظفين',
  // Staff live indicator
  liveCheckInIndicator: '<strong>{{count}}</strong> موظف سجل حضوره اليوم عبر لوحة التحكم — أوقات تسجيل الدخول ظاهرة في الجدول أدناه.',
  liveCheckInIndicatorPlural: '<strong>{{count}}</strong> موظفين سجلوا حضورهم اليوم عبر لوحة التحكم — أوقات تسجيل الدخول ظاهرة في الجدول أدناه.',
  // Class group header
  presentOf: 'حاضر',
  // Back button
  backToDashboard: 'العودة إلى لوحة التحكم',
  // On Leave status (staff)
  onLeaveLabel: 'في إجازة',

  // Action dropdown
  actionsFor: 'إجراءات لـ {{name}}',
  actions: 'إجراءات',
  alert: 'تنبيه',
  preInspectionTransitLogging: 'الفحص المسبق وتسجيل النقل',
  preInspectionDescription: 'المزاج، الحالة الجسدية، فحص الممتلكات',
  classroomIncidentEmergency: 'تسجيل الحوادث والطوارئ في الفصل',
  incidentDescription: 'نوع الحادث، مستوى الخطورة، الإجراءات المتخذة',

  // Pre-Inspection form
  newLog: 'سجل جديد',
  logHistory: 'سجل التاريخ',
  logAnother: 'تسجيل آخر',
  studentMood: 'مزاج الطالب',
  physicalState: 'الحالة الجسدية',
  belongingsOnPickup: 'الممتلكات عند الاستلام',
  additionalNotes: 'ملاحظات إضافية',
  notesPlaceholder: 'مثال: وصل الطالب باكياً، ذكر الوالد أنه لم ينم جيداً...',
  cannedMessages: 'رسائل جاهزة',
  notifyParent: 'إشعار ولي الأمر',
  notifyParentHint: 'إعداد وإرسال رسالة ملخص تلقائياً',
  sendVia: 'إرسال عبر',
  messagePreview: 'معاينة الرسالة',
  preInspectionUpdate: 'تحديث الفحص المسبق',
  dateLabel: 'التاريخ',
  moodLabel: 'المزاج',
  notesLabel: 'ملاحظات',
  notRecorded: 'غير مسجل',
  savePreInspection: 'حفظ سجل الفحص المسبق',
  preInspectionSaved: 'تم حفظ سجل الفحص المسبق!',
  preInspectionSavedHint: 'تم حفظ سجل الفحص المسبق لـ {{name}} بنجاح.',
  todayLogExists: 'يوجد سجل فحص مسبق لهذا الطالب اليوم. يمكنك إنشاء سجل آخر إذا لزم الأمر.',
  recordedBy: 'سجل بواسطة',
  noPreInspectionLogs: 'لا توجد سجلات فحص مسبق بعد',
  noPreInspectionLogsHint: 'أنشئ أول سجل باستخدام النموذج أعلاه',

  // Daywise Pre-Inspection Logs
  preInspectionLogs: 'سجلات الفحص المسبق',
  preInspectionLogsForDate: 'سجلات الفحص المسبق ليوم {{date}}',
  viewAllPreInspectionLogs: 'عرض جميع سجلات الفحص المسبق',
  noLogsForDate: 'لا توجد سجلات فحص مسبق لهذا التاريخ',
  noLogsForDateHint: 'ستظهر السجلات هنا عندما يسجل الموظفون الفحوصات المسبقة للطلاب',

  // Incident form
  newIncident: 'حادث جديد',
  incidentHistory: 'سجل الحوادث',
  incidentType: 'نوع الحادث',
  severityLevel: 'مستوى الخطورة',
  incidentLocation: 'الموقع',
  locationLabel: 'الموقع',
  incidentDescription: 'الوصف',
  incidentDescriptionPlaceholder: 'صف ما حدث بالتفصيل...',
  actionsTaken: 'الإجراءات المتخذة',
  actionsTakenPlaceholder: 'إسعافات أولية، تهدئة، اتصال بولي الأمر...',
  actionsTakenLabel: 'الإجراءات',
  staffInvolved: 'الموظفون المشاركون',
  staffInvolvedLabel: 'الموظفون',
  staffInvolvedPlaceholder: 'مثال: Ms. Emily Watson, Dr. Sarah Mitchell',
  followUpRequiredQuestion: 'هل المتابعة مطلوبة؟',
  followUpRequiredHint: 'وضع علامة على هذا الحادث للمراجعة اللاحقة',
  followUpRequired: 'متابعة مطلوبة',
  followUpNotes: 'ملاحظات المتابعة',
  followUpNotesPlaceholder: 'مثال: جدولة اجتماع مع ولي الأمر، المراقبة لمدة 3 أيام...',
  incidentNotifyParentHint: 'إرسال ملخص الحادث إلى ولي الأمر',
  saveIncident: 'حفظ تقرير الحادث',
  incidentSaved: 'تم حفظ تقرير الحادث!',
  incidentSavedHint: 'تم تسجيل تقرير الحادث لـ {{name}} بنجاح.',
  noIncidentLogs: 'لا توجد تقارير حوادث بعد',
  noIncidentLogsHint: 'أنشئ أول تقرير حادث باستخدام النموذج أعلاه',

  // Daywise incident logs
  incidentLogs: 'تقارير الحوادث',
  incidentLogsForDate: 'تقارير الحوادث ليوم {{date}}',
  viewAllIncidentLogs: 'عرض جميع تقارير الحوادث',
  noIncidentsForDate: 'لا توجد تقارير حوادث لهذا التاريخ',
  noIncidentsForDateHint: 'ستظهر التقارير هنا عندما يسجل الموظفون الحوادث للطلاب',
};

export default attendance;